"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgTShirtFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12 6a2 2 0 01-2-2h4a2 2 0 01-2 2z' }),
    react_1.default.createElement("path", { d: 'M19.188 5.781A4 4 0 0015.858 4h-.526c0 1.894-1.492 3.429-3.333 3.429-1.84 0-3.333-1.535-3.333-3.429H8.14a4 4 0 00-3.328 1.781L2 10l3.5 3 .944-1v6a2 2 0 002 2h7.112a2 2 0 002-2v-6l.944 1 3.5-3-2.813-4.219z' }))); };
exports.default = SvgTShirtFilled;
//# sourceMappingURL=TShirtFilled.js.map